import SignOut from "./SignOut";
import firebase from "./../Firebase";
import { useParams } from "react-router-dom";
import ParamsType from "../types/Types";
import { useCollectionData } from "react-firebase-hooks/firestore";

const ChatRoomHeader = () => {
  const { id } = useParams<ParamsType>();
  const query = firebase.firestore().collection("users").orderBy("isOnline");
  const [users] = useCollectionData(query, { idField: "id" });

  function findUserName() {
    const filterName = users?.find((user) => user.id === id)?.displayName;
    return filterName;
  }

  function getProfilePicUrl() {
    return firebase.auth().currentUser?.photoURL;
  }

  const title = id ? <p>{`Chat with ${findUserName()}`}</p> : <p>{"Main chat :)"}</p>;

  return (
    <div className="header-area">
      <div className="left-side">{title}</div>
      <div className="right-side">
        <img className="image" src={`${getProfilePicUrl()}`} alt="" width="70px" />
        <div className="sign-out">
          <SignOut />
        </div>
      </div>
    </div>
  );
};

export default ChatRoomHeader;
